module.exports = __webpack_public_path__ + "static/img/vipbg.a40957f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/vipbg.png
// module id = gQ2b
// module chunks = 0